var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{class:{ 'vp-app-workspace-color': !_vm.workspaceColorLoading }},[(
            !(_vm.authState == 'signedIn' && !_vm.baseLayout) ||
            _vm.platformLoading ||
            _vm.loadError ||
            !_vm.currentUserId
        )?[_c('BaseView',{attrs:{"app-loading":_vm.platformLoading,"load-error":_vm.loadError,"router-layout":_vm.baseLayout,"logged-in":_vm.authState == 'signedIn'}})]:[_c('v-main',{staticStyle:{"padding-top":"0"}},[_c('router-view',{attrs:{"logged-in":_vm.authState == 'signedIn',"user-id":_vm.currentUserId}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }